import { FormControl, FormLabel, Input, Text } from "@chakra-ui/react";
import { Controller } from "react-hook-form";
import get from "lodash/get";
interface InputProps {
  name: string;
  control: any;
  errors?: any;
  label: string | React.ReactNode;
  type?: string;
  placeholder?: string;
  isRequired?: boolean;
  min?: string | number;
  max?: string | number;
  maxLength?: number;
  step?: string | number;
  disable?: boolean;
  readOnly?: boolean;
  bgColor?: string;
  onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>;
}

const FormInput = ({
  name,
  control,
  errors,
  label,
  type = "text",
  placeholder,
  isRequired = false,
  min,
  max,
  maxLength,
  step,
  disable,
  readOnly,
  bgColor = "white",
  onKeyDown,
}: InputProps) => {
  const error = get(errors, name);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <FormControl isRequired={isRequired} isInvalid={!!error} mt={2}>
          <FormLabel className="font-poppins text_medium text_md">
            {label}
          </FormLabel>
          <Input
            {...field}
            type={type}
            placeholder={placeholder}
            min={min}
            max={max}
            maxLength={maxLength}
            step={step}
            disabled={disable}
            readOnly={readOnly}
            bg={bgColor}
            onKeyDown={onKeyDown}
            value={field.value ?? ""}
          />
          {error?.message && (
            <Text color="red.500" textAlign="left" fontSize="12px" mt={1}>
              {error.message}
            </Text>
          )}
        </FormControl>
      )}
    />
  );
};

export default FormInput;